import { InlineLoader } from '@dealstack/frontend/shared/components/loaders/InlineLoader/InlineLoader';
import { Box, rem } from '@mantine/core';
import { flexRender, Row } from '@tanstack/react-table';
import { memo } from 'react';
import styled from 'styled-components';

import type { IInvestorsProps } from './Investors.types';
import { useInvestorsController } from './useInvestorsController';

const Investors = ({ mipId }: IInvestorsProps) => {
	const investorsController = useInvestorsController(mipId);

	return (
		<Box pos="relative">
			<TableWrapper>
				{investorsController.getInvestorDataRequest.isLoading ? <InlineLoader /> : null}
				<table className="table" ref={investorsController?.tableContainerRef}>
					<thead>
						{investorsController?.tanstackTable.getHeaderGroups().map((headerGroup) => (
							<tr key={headerGroup.id}>
								{headerGroup.headers.map((header) => {
									return (
										<th
											key={header.id}
											colSpan={header.colSpan}
											style={{ width: header.getSize() }}
										>
											{header.isPlaceholder ? null : (
												<div
													{...{
														className: header.column.getCanSort()
															? 'cursor-pointer clickAnimation select-none'
															: '',
														onClick:
															header.column.getToggleSortingHandler(),
													}}
												>
													{flexRender(
														header.column.columnDef.header,
														header.getContext()
													)}
													{{
														asc: ' 🔼',
														desc: ' 🔽',
													}[header.column.getIsSorted() as string] ??
														null}
												</div>
											)}
										</th>
									);
								})}
							</tr>
						))}
					</thead>
					<tbody>
						{investorsController?.rowVirtualizer.getVirtualItems().map((virtualRow) => {
							const row = investorsController?.rows[virtualRow.index] as Row<object>;
							return (
								<tr key={row.id}>
									{row.getVisibleCells().map((cell) => {
										return (
											<td key={cell.id}>
												{flexRender(
													cell.column.columnDef.cell,
													cell.getContext()
												)}
											</td>
										);
									})}
								</tr>
							);
						})}
					</tbody>
				</table>
			</TableWrapper>
		</Box>
	);
};

const TableWrapper = styled.div`
	border: 1px solid lightgray;
	overflow: auto;
	max-height: 40rem;
	position: relative;

	table {
		border-collapse: collapse;
		border-spacing: 0;
		font-family: arial, sans-serif;
		table-layout: fixed;
		width: 100%;
	}

	thead {
		background: white !important;
		margin: 0;
		position: sticky;
		top: 0;
		opacity: 1;
		z-index: 1;
	}

	th {
		border-bottom: 1px solid lightgray;
		border-right: 1px solid lightgray;
		padding: ${rem(2)} ${rem(4)};
		text-align: left;
	}

	td {
		padding: ${rem(10)} ${rem(6)};
	}

	button {
		:focus {
			border: none;
		}
	}
`;
const _InvestorsExport = memo(Investors);

export { _InvestorsExport as Investors };
